import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import store from "./store";
import NotImplemented from "./pages/NotImplemented";
import PoliticaDePrivacidadScreen from "./pages/PoliticaDePrivacidadScreen";
import TerminosYCondicionesScreen from "./pages/TerminosYCondicionesScreen";
import ProteccionDeDatosScreen from "./pages/ProteccionDeDatosScreen";
import CookiesScreen from "./pages/CookiesScreen";
import JobsScreen from "./pages/JobsScreen";
import JobViewScreen from "./pages/JobViewScreen";
import AcceptLopdConfirmationScreen from "./pages/AcceptLopdConfirmationScreen";
import InscripcionAceptadaConfirmationScreen from "./pages/InscripcionAceptadaConfirmationScreen";
import AcceptLopdFormScreen from "./pages/AcceptLopdFormScreen";

import history from "./history";
import { setI18nConfig  } from "./util/Translator";

function App( props ) {

  const [loading, setLoading] = React.useState(true);

  const [language, setLanguage] = React.useState(
    localStorage.getItem('language') || 'es'
  );

  React.useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const cookiesAccepted = true;

  /*const [cookiesAccepted, setCookiesAccepted] = React.useState(
    localStorage.getItem('cookiesAccepted') || 'false'
  );

  React.useEffect(() => {
    localStorage.setItem('cookiesAccepted', cookiesAccepted);
  }, [cookiesAccepted]);

  React.useEffect(() => {
    if (cookiesAccepted !== 'true') {

      window.$('#cookiesModalDialog').modal({});

    }
  });*/

  const onChangeLanguage = lng => {
    setI18nConfig(lng);
    setLanguage(lng);
  }

  if (loading) {
    setI18nConfig(language);
    setLoading(false);
    console.log("process.env.PUBLIC_URL", process.env.PUBLIC_URL);
    console.log("process.env.NODE_ENV", process.env.NODE_ENV);
   
    if (window.$ != null) {
      /*window.$('#cookiesModalDialog').on('hidden.bs.modal', function (e) {
        setCookiesAccepted('true');
      });*/
    }
  }

  const onClickVerPoliticaDeCookies = (history) => {
    history.push('/home/cookies');
    window.$('#cookiesModalDialog').modal('hide');
  }

  const onClickContinuar = () => {
    window.$('#cookiesModalDialog').modal('hide');
    //setCookiesAccepted('true');
  }
  
  return (
    <Fragment>
      <Provider store={store}>
        <Router basename={process.env.PUBLIC_URL} history={history}>
          <Header selectedLanguage={language} onChangeLanguage={ (lng) => onChangeLanguage(lng) }/>
          { cookiesAccepted === 'true' ? null :
            <div>
              <div className="modal fade" id="cookiesModalDialog" tabindex="-1" role="dialog" 
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalCenterTitle">Atención</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      Esta página web utiliza cookies. Si continuas trabajando con la
                      configuración actual se entiende que consientes su uso, de todas
                      formas siempre puedes cambiar la configuración de las cookies en
                      el navegador.
                    </div>
                    <div className="modal-footer">
                      <a className="btn btn-secondary" href="https://www.google.com/">Salir</a>
                      <button type="button" className="btn btn-secondary" onClick={(e) => onClickVerPoliticaDeCookies(history)}>
                        Ver política de cookies
                      </button>
                      <button type="button" className="btn btn-primary" onClick={(e) => onClickContinuar()}>
                        Aceptar y continuar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <Switch>
            <Route exact path="/" render={(props) => <Home {...props} selectedLanguage={language} />} />
            <Route exact path="/home" render={(props) => <Home {...props} selectedLanguage={language} />} />
            <Route exact path="/home/politicaDePrivacidad" component={PoliticaDePrivacidadScreen} />
            <Route exact path="/home/terminosYCondiciones" component={TerminosYCondicionesScreen} />
            <Route exact path="/home/proteccionDeDatos" component={ProteccionDeDatosScreen} />
            <Route exact path="/home/cookies" component={CookiesScreen} />
            <Route exact path="/home/accept-rgpd" render={(props) => <AcceptLopdFormScreen {...props} selectedLanguage={language} />} />
            <Route exact path="/home/accept-rgpd/confirmed" render={(props) => <AcceptLopdConfirmationScreen {...props} selectedLanguage={language} />} />          
            <Route exact path="/jobs" render={(props) => <JobsScreen {...props} selectedLanguage={language} />} />
            <Route exact path="/jobs/:id" render={(props) => <JobViewScreen {...props} selectedLanguage={language} />} />
            <Route exact path="/jobs/:id/create-confirmed" render={(props) => <InscripcionAceptadaConfirmationScreen {...props} selectedLanguage={language} />} />
            
            <Route component={NotImplemented} />
          </Switch>
          
          <Footer />
        </Router>
      </Provider>
    </Fragment>
  );
}

export default App;
